import "core-js";//commit per nuova build
window._ = require('lodash');

window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');
require('bootstrap');
window.moment = require('moment');
require('moment/locale/it');
window.moment.locale('it');
window.Vue = require('vue');
require('./vue/filter');

require('./prototypes/prototype');
require('./helpers/basehelper');
require('tempusdominus-bootstrap-4')
require('./helpers/jquery.jqprint');
window.Swal = require('sweetalert2');
import Idoc from './helpers/Idoc.js';
window.Idoc = Idoc; /* questo serve ad averlo globale anche in cose fuori Vue o non compilate */
require('./frontend/bootstrap3-typeahead.min');
require('./frontend/history.min');
require('./frontend/history.adapter.jquery.min');
require('./frontend/functions');
require('./frontend/globalvariables');
require('./frontend/startup');
require('./frontend/clinica');
require('./frontend/liste')
require('./frontend/cercatore');
require('./frontend/medico');
require('./frontend/registrazione');
require('./frontend/prenota');
require('./frontend/articolo');
require('./frontend/pubblicazione');
require('./vue/baseAppFrontend');
require('./frontend/favorites');
require('./frontend/condividi');
require('./shareapi');
require('./recorder');

require('../assets/libraries/ekkolightbox/ekko-lightbox.min.js')

require('ddslick/dist/jquery.ddslick.min.js');

import ReviewsMedico from './vue/pages/Frontend/ReviewsMedico.vue';
Vue.component('reviewsmedico', ReviewsMedico);

import DisponibilitaMedico from './vue/pages/Frontend/DisponibilitaMedico.vue';
Vue.component('disponibilitamedico', DisponibilitaMedico);

import DisponibilitaClinica from './vue/pages/Frontend/DisponibilitaClinica.vue';
Vue.component('disponibilitaclinica', DisponibilitaClinica);

import DisponibilitaListe from './vue/pages/Frontend/DisponibilitaListe.vue';
Vue.component('disponibilitaliste', DisponibilitaListe);

import AiListe from './vue/pages/Frontend/AiListe.vue';
Vue.component('ailiste', AiListe);